// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './lang/en.json'
import ru from './lang/ru.json'

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'ru',
  messages: {en,ru}
})
